import React, { useCallback } from 'react'
import { MAIN_PHONE_NUMBER } from '@constants/index'
import { Map, Placemark, YMaps } from '@pbe/react-yandex-maps'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { isProduction } from '@shared/pipes/config'
import Head from 'next/head'
import { DEFAULT_CITY } from 'regions/list'

import styles from './style.module.scss'

const jsonLD = (city?: string) => ({
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: 'Credit.Club',
	address: {
		'@type': 'PostalAddress',
		streetAddress: 'БЦ «Высоцкий», ул. Малышева 51, офис 26/14',
		addressLocality: 'Екатеринбург',
		addressRegion: 'Свердловская область',
		postalCode: '620000',
		addressCountry: {
			'@type': 'Country',
			name: 'RU',
		},
	},
	telephone: '+7 800 775 80 09',
	url: `https://credit.club/${city ?? DEFAULT_CITY}`,
	logo: 'https://credit.club/og/images/graph-loan.jpg',
	image: 'https://credit.club/og/images/graph-loan.jpg',
	sameAs: [
		'https://vk.com/credit.club',
		'https://www.youtube.com/channel/UCmSKC-7TCBJEQla4Mfo-Gzg/videos',
		'https://dzen.ru/procent_creditclub',
	],
	description:
		'Кредит под залог квартиры на любые цели. Без страховок и скрытых комиссий. Любая кредитная история. Быстрое решение.',
})

const contacts = [
	{ label: 'Телефон', value: MAIN_PHONE_NUMBER, type: 'tel' },
	{ label: 'Почта', value: 'platform@credit.club', type: 'email' },
	{ label: 'Главный офис', value: 'Екатеринбург, БЦ «Высоцкий», ул. Малышева 51, офис 26/14' },
]

const coordinates = [56.836101, 60.614578]

const View = (props: { city?: string }) => {
	const renderContact = useCallback((value, type) => {
		if (type === 'tel')
			return (
				<a href={`tel:${value}`} className={styles.value}>
					{value}
				</a>
			)

		if (type === 'email')
			return (
				<a href={`mailto:${value}`} className={styles.value}>
					{value}
				</a>
			)

		return <p className={styles.value}>{value}</p>
	}, [])

	return (
		<PageAnimation>
			<Head>
				<script type='application/ld+json'>{JSON.stringify(jsonLD(props.city))}</script>
			</Head>
			<Section className={styles.wrapper}>
				<h1 className={styles.title}>Контакты</h1>
				<div className={styles.columns}>
					<h2 className={styles.subtitle}>
						Платформа для финансирования бизнеса и надёжных инвестиций
					</h2>
					<h3 className={styles.h4}>Работаем в крупных городах России</h3>
				</div>
				<div className={styles.contacts}>
					{contacts.map(({ label, value, type }, index) => (
						<div key={index} className={styles.contactBlock}>
							<p className={styles.label}>{label}</p>
							{renderContact(value, type)}
						</div>
					))}
				</div>
			</Section>
			<Section className={styles.map}>
				<YMaps
					query={{
						apikey: 'b4a0cc9e-bbaa-4581-8fbc-0984b9004d26',
						mode: isProduction ? 'release' : 'debug',
					}}
				>
					<Map
						state={{
							center: coordinates,
							zoom: 16,
						}}
						width='100%'
						height='100%'
					>
						<Placemark geometry={coordinates} />
					</Map>
				</YMaps>
			</Section>
		</PageAnimation>
	)
}

export default View
